import React from "react";
import Styles from "./styles";
import { GatsbyImage } from "gatsby-plugin-image";
import { useIntl } from "gatsby-plugin-react-intl";
import { useStaticQuery, graphql } from "gatsby";

const { ImageWrapper, InfoWrapper } = Styles;

const Services = () => {
  const intl = useIntl();

  const { allFile } = useStaticQuery(graphql`
    query servicesQuery {
      allFile(filter: { name: { eq: "info-1" } }) {
        edges {
          node {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `);

  return (
    <>
      <ImageWrapper>
        <GatsbyImage
          style={{
            width: "100%",
            maxHeight: "100%",
            minHeight: "100%",
          }}
          objectFit={"cover"}
          image={allFile.edges[0].node.childImageSharp.gatsbyImageData}
          alt={intl.formatMessage({ id: "addInfo1" })}
        />
      </ImageWrapper>
      <InfoWrapper>
        <h2>{intl.formatMessage({ id: "servicesTitle1" })}</h2>
        <p>{intl.formatMessage({ id: "servicesText1" })}</p>
        <ul>
          {(() => {
            let rows = [];
            for (let i = 2; i < 28; i++) {
              rows.push(
                <li key={i}>
                  {intl.formatMessage({ id: `servicesInfo${i}` })}
                </li>
              );
            }
            return rows;
          })()}
        </ul>
      </InfoWrapper>
    </>
  );
};

export default Services;
